import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "../../../../../../../../types"
import { useApi } from "../../../../../../../../utils"

export function useCategory() {
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState(false)

  const refetch = () => {
    setLoading(true)

    api.get("/categorycustomer/")
    .then((res: SuccessFetch<{
      payload: {
        category_customer_id: number
        category_customer_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.category_customer_name, value: item.category_customer_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  }

  useEffect(() => {
    setLoading(true)

    api.get("/categorycustomer/")
    .then((res: SuccessFetch<{
      payload: {
        category_customer_id: number
        category_customer_name: string
    }[]}>) => { setData(res.data.payload.map(item => { return { label: item.category_customer_name, value: item.category_customer_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
    // eslint-disable-next-line
  }, [])

  return { data, isLoading, refetch }
}